import { render, staticRenderFns } from "./DetalleAcumuladoModal.vue?vue&type=template&id=83cb08aa"
import script from "./DetalleAcumuladoModal.vue?vue&type=script&lang=js"
export * from "./DetalleAcumuladoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports